import { AxiosInstance } from "axios";
import { BannerMessage } from "../types/BannerMessage/BannerMessage";
import { Pagination } from "../types/PaginiationResult";

export default class BannerMessageService {
  private _endpoint = "BannerMessage";
  private _client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this._client = client;
  }

  public async Create(request: any): Promise<BannerMessage> {
    const response = await this._client.post<BannerMessage>(
      this._endpoint,
      request
    );
    return response.data;
  }

  public async Update(request: any): Promise<BannerMessage> {
    const response = await this._client.put<BannerMessage>(
      this._endpoint,
      request
    );
    return response.data;
  }

  public async Delete(id: number): Promise<void> {
    await this._client.delete(`${this._endpoint}/${id}`);
  }

  public async GetCurrent(): Promise<BannerMessage | null> {
    const response = await this._client.get<BannerMessage | null>(
      `${this._endpoint}/current`
    );
    return response.data;
  }

  public async List(
    page?: number,
    pageSize?: number
  ): Promise<Pagination<BannerMessage>> {
    const response = await this._client.get(this._endpoint, {
      params: { page, pageSize },
    });
    return response.data;
  }
}
